import BaseService from '@/api/services/index'
import Settings from '@/api/models/Settings'
import SettingsMapping from '@/api/models/SettingsMapping'
import OrderStatusesDto from '@/api/dto/OrderStatusesDto'
import ReturnStatusesDto from '@/api/dto/ReturnStatusesDto'
import PaymentTypesDto from '@/api/dto/PaymentTypesDto'
import WarehousesDto from '@/api/dto/WarehousesDto'
import CostMappingDto from '@/api/dto/CostMappingDto'
import CatalogManagementDto from '@/api/dto/CatalogManagementDto'

export default class SettingsService extends BaseService {
    public async getBase (accountId: number|undefined, campaignId: number): Promise<Settings> {
        return this.api.get<never, Settings>(
            this.getUrl('account_campaign_get_settings_base', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async updateBase (accountId: number|undefined, campaignId: number, settings: Settings): Promise<Settings> {
        return this.api.put<Settings, Settings>(
            this.getUrl('account_campaign_update_settings_base', { accountId: accountId, campaignId: campaignId }),
            settings
        )
    }

    public async getPriceLink (accountId: number|undefined, campaignId: number): Promise<string|object> {
        return this.api.get<never, string|object>(
            this.getUrl('account_campaign_get_price_list', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async getNotificationKey (accountId: number|undefined, campaignId: number): Promise<string|object> {
        return this.api.get<never, string|object>(
            this.getUrl('account_campaign_get_notification_key', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async getOrderStatusMapping (accountId: number|undefined, campaignId: number): Promise<Array<SettingsMapping>> {
        return this.api.get<never, Array<SettingsMapping>>(
            this.getUrl('account_campaign_get_settings_statuses', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async updateOrderStatusMapping (accountId: number|undefined, campaignId: number, mapping: OrderStatusesDto): Promise<Array<SettingsMapping>> {
        return this.api.put<OrderStatusesDto, Array<SettingsMapping>>(
            this.getUrl('account_campaign_update_settings_statuses', { accountId: accountId, campaignId: campaignId }),
            mapping
        )
    }

    public async getReturnStatusMapping (accountId: number|undefined, campaignId: number): Promise<ReturnStatusesDto> {
        return this.api.get<never, ReturnStatusesDto>(
            this.getUrl('account_campaign_get_settings_return_statuses', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async updateReturnStatusMapping (accountId: number|undefined, campaignId: number, mapping: ReturnStatusesDto): Promise<ReturnStatusesDto> {
        return this.api.put<ReturnStatusesDto, ReturnStatusesDto>(
            this.getUrl('account_campaign_update_settings_return_statuses', { accountId: accountId, campaignId: campaignId }),
            mapping
        )
    }

    public async getPaymentsMapping (accountId: number|undefined, campaignId: number): Promise<Array<SettingsMapping>> {
        return this.api.get<never, Array<SettingsMapping>>(
            this.getUrl('account_campaign_get_settings_payment_types', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async updatePaymentsMapping (accountId: number|undefined, campaignId: number, mapping: PaymentTypesDto): Promise<Array<SettingsMapping>> {
        return this.api.put<PaymentTypesDto, Array<SettingsMapping>>(
            this.getUrl('account_campaign_update_settings_payment_types', { accountId: accountId, campaignId: campaignId }),
            mapping
        )
    }

    public async getWarehousesMapping (accountId: number|undefined, campaignId: number): Promise<WarehousesDto> {
        return this.api.get<never, WarehousesDto>(
            this.getUrl('account_campaign_get_warehouses', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async updateWarehousesMapping (accountId: number|undefined, campaignId: number, mapping: WarehousesDto): Promise<WarehousesDto> {
        return this.api.put<WarehousesDto, WarehousesDto>(
            this.getUrl('account_campaign_update_warehouses', { accountId: accountId, campaignId: campaignId }),
            mapping
        )
    }

    public async getCosts (accountId: number|undefined, campaignId: number): Promise<CostMappingDto> {
        return this.api.get<never, CostMappingDto>(
            this.getUrl('account_campaign_get_costs', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async updateCosts (accountId: number|undefined, campaignId: number, mapping: CostMappingDto): Promise<CostMappingDto> {
        return this.api.put<CostMappingDto, CostMappingDto>(
            this.getUrl('account_campaign_update_costs', { accountId: accountId, campaignId: campaignId }),
            mapping
        )
    }

    public async getCatalogManagementMapping (accountId: number|undefined, campaignId: number): Promise<Array<CatalogManagementDto>> {
        return this.api.get<never, Array<CatalogManagementDto>>(
            this.getUrl('account_campaign_get_catalog_mapping', { accountId: accountId, campaignId: campaignId })
        )
    }

    public async updateCatalogManagementMapping (accountId: number|undefined, campaignId: number, mapping: CatalogManagementDto): Promise<Array<CatalogManagementDto>> {
        return this.api.put<CatalogManagementDto, Array<CatalogManagementDto>>(
            this.getUrl('account_campaign_update_catalog_mapping', { accountId: accountId, campaignId: campaignId }),
            mapping
        )
    }
}
